import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { InstructorService } from "../report-services/instructor.service";
import { Course1Service } from "../report-services/course1.service";
import { Course2Service } from "../report-services/course2.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import * as moment from "moment";

@Component({
	templateUrl: "./classattendancetrackingdetails.component.html",
})
export class ClassAttendanceTrackingDetailsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private course2Service: Course2Service,
		private course1Service: Course1Service,
		private instructorService: InstructorService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		InstructorID: 0,
		Course1ID: 0,
		Course2ID: 0,
		CourseLike: "",
		OrderByID: "Average Percent",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	InstructorList: any = [];
	Course1List: any = [];
	Course2List: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	OrderByList = [
		//Insert Custom List Items Here
		{
			OrderByID: "Average Percent",
			OrderByName: "Average Percent",
		},
		{
			OrderByID: "Instructor",
			OrderByName: "Instructor",
		},
		{
			OrderByID: "Instructor Code",
			OrderByName: "Instructor Code",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 271;
	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadInstructorList()
		// this.loadCourse1List()
		// this.loadCourse2List()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadInstructorList();
		this.loadCourse1List();
		this.loadCourse2List();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(271);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadInstructorList() {
		this.report.InstructorID = 0;
		var result = this.instructorService.loadInstructorList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.InstructorList = response;

				if (this.InstructorList.length > 1) {
					this.InstructorList.unshift({
						Teacher_PersonID: 0,
						Instructor: "All Instructors",
					});
				} else {
					this.report.InstructorID = this.InstructorList[0].InstructorID;
				}
			},
			(error) => {}
		);
	}

	private loadCourse1List() {
		this.report.Course1ID = 0;
		var result = this.course1Service.loadCourse1List(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.Course1List = response;

				if (this.Course1List.length > 1) {
					// this.Course1List.unshift({
					//     CourseID: 0,
					//     CourseDesc: "All Courses"
					// })
					this.report.Course1ID = this.Course1List[0].CourseID;
				} else {
					this.report.Course1ID = this.Course1List[0].CourseID;
				}
			},
			(error) => {}
		);
	}

	private loadCourse2List() {
		this.report.Course1ID = 0;
		var result = this.course2Service.loadCourse2List(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.Course2List = response;

				if (this.Course2List.length > 1) {
					// this.Course2List.unshift({
					//     CourseID: 0,
					//     CourseDesc: "All Courses"
					// })
					this.report.Course1ID = this.Course2List[0].CourseID;
				} else {
					this.report.Course1ID = this.Course2List[0].CourseID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.InstructorID) {
		// 	this.errorMessage = "Select the Instructor"
		// 	return;
		// }

		// if (!this.report.Course1ID) {
		// 	this.errorMessage = "Select the Course1"
		// 	return;
		// }

		// if (!this.report.Course1ID) {
		// 	this.errorMessage = "Select the Course2"
		// 	return;
		// }

		// if (!this.report.CourseLike) {
		// 	this.errorMessage = "Select the CourseLike"
		// 	return;
		// }

		// if (!this.report.OrderByID) {
		// 	this.errorMessage = "Select the OrderBy"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 271;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: InstructorID
		strParam += "," + this.report.InstructorID + "|InstructorID";

		//Parameter 5: CourseID1
		strParam += "," + this.report.Course1ID + "|CourseID1";

		//Parameter 6: CourseID2
		strParam += "," + this.report.Course1ID + "|CourseID2";

		//Parameter 7: CourseLike
		strParam += "," + this.report.CourseLike + "|CourseLike";

		//Parameter 8: OrderBy
		strParam += "," + this.report.OrderByID + "|OrderBy";

		//Parameter 9: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
